"use client";

import React, { ComponentProps, ElementType } from "react";
import Button, { ButtonProps } from "../Button/Button";
import {
  callToActionClasses,
  type CallToActionVariants,
} from "./CallToAction.style";

export type CallToActionProps = Pick<ButtonProps, "size" | "color"> &
  CallToActionVariants &
  ComponentProps<"div"> & {
    onSave?: () => void;
    onCancel?: () => void;
    onSaveLink?: string;
    onCancelLink?: string;
    onSaveLabel?: string;
    onCancelLabel?: string;
    onSaveColor?: ButtonProps["color"];
    onCancelColor?: ButtonProps["color"];
    onSaveHidden?: boolean;
    onCancelHidden?: boolean;
    component?: ElementType;
    onSaveRender?: ButtonProps["render"];
    onCancelRender?: ButtonProps["render"];
    isResponsive?: boolean;
    className?: string;
  };

const CallToAction = React.forwardRef<HTMLElement, CallToActionProps>(
  function CallToAction(props, ref) {
    const {
      onCancel = () => {},
      onSave = () => {},
      onSaveLink,
      onCancelLink,
      onCancelLabel = "Cancel",
      onSaveLabel = "Save",
      size = "medium",
      spacing = "16",
      align = "left",
      color = "primary",
      isResponsive,
      className,
      onSaveColor,
      onCancelColor,
      onSaveHidden = false,
      onCancelHidden = false,
      component: Component = "div",
    } = props;

    if (!props.onSaveLabel && !props.onCancelLabel) return null;

    return (
      <Component
        ref={ref}
        className={callToActionClasses({
          spacing,
          align,
          isResponsive,
          class: className,
        })}
      >
        {!onSaveHidden && (
          <Button
            autoFocus={false}
            href={onSaveLink}
            label={onSaveLabel}
            variant="contained"
            color={onSaveColor || color}
            onClick={onSave}
            size={size}
            className="justify-center"
            render={props.onSaveRender}
          />
        )}
        {!onCancelHidden && (
          <Button
            autoFocus={false}
            href={onCancelLink}
            label={onCancelLabel}
            variant="outlined"
            color={onCancelColor || color}
            size={size}
            onClick={onCancel}
            className="justify-center"
            render={props.onCancelRender}
          />
        )}
      </Component>
    );
  }
);

export default CallToAction;
